// src/components/DriverRideTimer.js
import { useCountdown } from "../../hooks/useCoundown.js";

export const DriverRideTimer = ({ ride, onEnd }) => {
  // ✅ Ensure we have valid values
  const startTime = ride?.SPL_TASK_ST_TIME;
  const duration = ride?.SPL_RIDE_DURATION;
  const rideId = ride?.RIDE_ID || "default";

  // ✅ Persistent countdown across refresh
  const remaining = useCountdown(startTime, duration, onEnd, rideId);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  return (
    <div className="ride-timer">
      <h4>⏳ Ride Timer</h4>
      {duration && startTime ? (
        <p>
          {minutes}:{seconds.toString().padStart(2, "0")}
        </p>
      ) : (
        <p>Waiting for ride start...</p>
      )}
    </div>
  );
};
